import { render, staticRenderFns } from "./DealerUsers.vue?vue&type=template&id=f64e0edc&scoped=true"
import script from "./DealerUsers.vue?vue&type=script&lang=js"
export * from "./DealerUsers.vue?vue&type=script&lang=js"
import style0 from "./DealerUsers.vue?vue&type=style&index=0&id=f64e0edc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64e0edc",
  null
  
)

export default component.exports